import { type FilterItem } from 'widgets/FilterEditor/model'

export const isAsyncTagsWidget = (filterItem: FilterItem) =>
  filterItem.key === 'tag' &&
  !!filterItem.config.is_values_required &&
  !filterItem.config.hasOwnProperty('values')
